
import mammoth from 'mammoth';
import * as pdfjsLib from 'pdfjs-dist';

// [FIX] Menggunakan worker lokal yang sudah dicopy ke folder public
// Ini lebih stabil daripada CDN dan menghindari error versi/MIME type
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';

/**
 * Mendeteksi tipe file dan mengekstrak teksnya.
 * Mendukung: .txt, .docx, .pdf
 * @param {File} file 
 * @returns {Promise<string>} Text content
 */
export const parseDocument = async (file) => {
    return new Promise(async (resolve, reject) => {
        console.log("Parsing document:", file.name, file.type);

        try {
            // 1. Handle DOCX (Word Document)
            if (
                file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                file.name.toLowerCase().endsWith('.docx')
            ) {
                console.log("Processing as DOCX...");
                const arrayBuffer = await file.arrayBuffer();
                const result = await mammoth.extractRawText({ arrayBuffer });

                if (result.value) {
                    resolve(result.value);
                } else {
                    reject(new Error("Gagal membaca teks dari dokumen Word. Pastikan file tidak rusak."));
                }
                return;
            }

            // 2. Handle PDF
            if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
                console.log("Processing as PDF...");
                const arrayBuffer = await file.arrayBuffer();
                const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
                const pdf = await loadingTask.promise;

                let fullText = '';
                // Loop setiap halaman untuk ambil teks
                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);
                    const textContent = await page.getTextContent();
                    const pageText = textContent.items.map(item => item.str).join(' ');
                    fullText += pageText + '\n\n';
                }

                if (fullText.trim()) {
                    resolve(fullText);
                } else {
                    reject(new Error("PDF kosong atau berisi gambar (bukan teks yang bisa dibaca)."));
                }
                return;
            }

            // 3. Fallback: Default Text Reader (untuk .txt)
            // Jika memaksa baca binary lain (misal .doc lama), ini akan hasilkan garbage (seperti screenshot user)
            // Tapi kita batasi ekspektasi user ke .docx dan .pdf
            console.log("Processing as Plain Text...");
            const reader = new FileReader();

            reader.onload = (e) => {
                const text = e.target.result;
                // Basic check untuk melihat apakah hasil bacaan adalah binary garbage
                // Jika banyak karakter , kemungkinan file binary salah baca
                if (text.includes('') && text.length > 50) {
                    console.warn("Detected potential binary garbage content.");
                }
                resolve(text);
            };

            reader.onerror = (e) => reject(new Error("Gagal membaca file: " + e.target.error));
            reader.readAsText(file);

        } catch (error) {
            console.error("Error parsing document:", error);
            reject(new Error("Gagal memproses dokumen: " + error.message));
        }
    });
};
